import ActivityResult from './ActivityResult';

export default (props) => {
  return <ActivityResult {...props} />;
};
